import { useNavigate } from "react-router-dom";
import textWeight from "../../utils/textWeight";
import { useRef, useState } from "react";

export default () => {
  const { TextWeight } = textWeight();
  const navigate = useNavigate();
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const inputRef = useRef(null);

  const handleFocusInput = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };
  return {
    TextWeight,
    navigate,
    isPasswordVisible,
    handleFocusInput,
    togglePasswordVisibility,
    inputRef,
  };
};
